export default function maxIndex(values, valueof) {
    var max;
    var maxIndex = -1;
    var index = -1;
    if (valueof === undefined) {
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            ++index;
            if (value != null
                && (max < value || (max === undefined && value >= value))) {
                max = value, maxIndex = index;
            }
        }
    }
    else {
        for (var _a = 0, values_2 = values; _a < values_2.length; _a++) {
            var value = values_2[_a];
            if ((value = valueof(value, ++index, values)) != null
                && (max < value || (max === undefined && value >= value))) {
                max = value, maxIndex = index;
            }
        }
    }
    return maxIndex;
}
